import AppIcon from "./AppIcon";
export default AppIcon({
  fill: "blue",
  text: "Kp"
});